import { __assign, __read, __spread } from "tslib";
import React, { useState } from 'react';
import { sum } from 'lodash-es';
import { Box, Flex, RangeSlider, SearchInput } from '@marvelapp/ui';
import { gridImagesPerBreakpoint, NoItems, ProjectGridContainer, useImagesPerRowHelper, } from '@marvelapp/ui-internal';
import { getAspectRatio, getThumbnailImagePadding } from '@marvelapp/core';
import NavigationGridHeader from './NavigationGridHeader';
import NavigationGridItem from '../containers/NavigationGridItem';
import NavigationGridModal from './NavigationGridModal';
import NavigationGridWrap from './NavigationGridWrap';
import { getFormattedImageUrl } from '../utils/image';
export default function NavigationGrid(_a) {
    var currentScreenID = _a.currentScreenID, frame = _a.frame, groupedScreens = _a.groupedScreens, onClose = _a.onClose, onSelect = _a.onSelect, orientation = _a.orientation, projectName = _a.projectName, ungroupedScreens = _a.ungroupedScreens;
    var _b = __read(useState(''), 2), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = useImagesPerRowHelper(), imagesPerRow = _c.imagesPerRow, setImagesPerRow = _c.setImagesPerRow, breakpointValue = _c.breakpointValue, sliderPosition = _c.sliderPosition, setSliderPosition = _c.setSliderPosition;
    var gridItemAspectRatio = getAspectRatio(frame, orientation);
    var handleSearch = function (value) {
        setSearchQuery(value);
    };
    var isScreenVisible = function (screen) {
        return screen.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
    };
    var renderGridItem = function (screen) {
        var screenThumbUrl = getFormattedImageUrl(screen.img, 320, gridItemAspectRatio);
        var imagePadding = getThumbnailImagePadding({
            url: screen.img.previewURL,
            height: screen.img.height,
            width: screen.img.width,
        }, gridItemAspectRatio);
        return (React.createElement(NavigationGridItem, { imagesPerRow: imagesPerRow || 5, isActive: screen.id === currentScreenID, key: screen.id, name: screen.name, onClick: function () { return onSelect(screen.id); }, previewImagePadding: imagePadding, previewImageURL: screenThumbUrl, screenID: screen.id, searchQuery: searchQuery }));
    };
    var visibleUngroupedScreens = ungroupedScreens.filter(isScreenVisible);
    var visibleGroupedScreens = groupedScreens
        .map(function (screenGroup) { return (__assign(__assign({}, screenGroup), { screens: screenGroup.screens.filter(isScreenVisible) })); })
        .filter(function (screenGroup) { return screenGroup.screens.length > 0; });
    var visibleScreensCount = sum(__spread([
        visibleUngroupedScreens.length
    ], visibleGroupedScreens.map(function (group) { return group.screens.length; })));
    var visibleScreensCountWord = visibleScreensCount === 1 ? 'screen' : 'screens';
    var showEmptyState = visibleScreensCount === 0;
    return (React.createElement(NavigationGridModal, { onClose: onClose },
        React.createElement(NavigationGridHeader, { onClose: onClose, subheading: visibleScreensCount + " " + visibleScreensCountWord, title: projectName }),
        React.createElement(Box, { display: showEmptyState ? 'flex' : 'block', flex: 1, overflow: "auto", py: 4 },
            React.createElement(ProjectGridContainer, { display: "flex", flex: 1, flexDirection: "column" },
                React.createElement(Flex, { justifyContent: "space-between", my: 4 },
                    React.createElement(Box, null,
                        React.createElement(RangeSlider, { max: 2, min: 0, onChange: function (event) {
                                setSliderPosition(event.target.value);
                                setImagesPerRow(gridImagesPerBreakpoint[breakpointValue][event.target.value]);
                            }, value: sliderPosition })),
                    React.createElement(Box, { paddingRight: 5 },
                        React.createElement(SearchInput, { onChange: handleSearch, placeholder: "Search screens", searchTerm: searchQuery, value: searchQuery }))),
                showEmptyState ? (React.createElement(Box, { flex: 1, paddingBottom: 1 },
                    React.createElement(NoItems, { height: "100%", testId: "no-results", title: "No search results found." }))) : (React.createElement(React.Fragment, null,
                    React.createElement(NavigationGridWrap, null, visibleUngroupedScreens.map(renderGridItem)),
                    visibleGroupedScreens.map(function (group) { return (React.createElement(NavigationGridWrap, { groupName: group.name, key: group.id, screenCount: group.screens.length }, group.screens.map(renderGridItem))); })))))));
}
